import styled from 'styled-components';

export const BroadcastModerationStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const BroadcastModerationBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BroadcastModerationGridStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 4px;
`;

export const BroadcastModerationLabelStyled = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray[90]};
`;
